

import { Box, Button, Card, Flex, Heading } from 'rebass';
import PropTypes from 'prop-types';
import React from 'react';

import { useUploadBatch } from './hooks';
import Modal from '../../app/modal/v2';
import UploadMediumStatus from './medium-status';

// Closing is just closing. This used to dispatch clearUploadBatch() before calling
// onClose, which threw away the whole progress list -- so closing the details while
// files were still uploading left nothing for the "Show Details" link to show, and
// the link disappeared with it. The uploads kept going; the person just lost sight
// of them.
//
// Whether the batch should be cleared depends on whether the uploads have finished,
// and only the parent knows that. See UploadManager's closeModal.
const UploadManagerModal = ({ onClose }) => {
  const uploadBatch = useUploadBatch();

  return (
    <Modal>
      <Card borderTopLeftRadius={8} borderTopRightRadius={8} bg="bgGrey" p={4}>
        <Heading fontFamily="quicksand" fontSize={4}>
          Upload Details
        </Heading>
      </Card>
      <Box css="overflow: auto; max-height: 40vh;">
        {uploadBatch.map(item => (
          <UploadMediumStatus key={`uploading-${item.id}`} {...item} />
        ))}
      </Box>
      <Card
        as={Flex}
        justifyContent="flex-end"
        borderBottomLeftRadius={8}
        borderBottomRightRadius={8}
        bg="bgGrey"
        p={3}
      >
        <Button
          variant="primary"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
      </Card>
    </Modal>
  );
};

UploadManagerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default UploadManagerModal;
